import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { WorkflowFile } from 'app/models/workflow-file';
import { ModalDirective } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-add-edit-auto-start-file',
  templateUrl: './add-edit-auto-start-file.component.html',
  styleUrls: ['./add-edit-auto-start-file.component.scss']
})
export class AddEditAutoStartFileComponent implements OnInit {

  @ViewChild('addEditAutoStartFileModal', { static: true }) addEditAutoStartFileModal: ModalDirective;

  @Output() addEditAccepted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

  @Input() workflowFiles: WorkflowFile[];
  @Input() isEdit: boolean;

  autoStartFileToAddFormGroup: FormGroup;

  constructor(private validationHandler: ValidationHandler) { }

  ngOnInit(): void {
  }
  
  show(frm: FormGroup) {
    this.autoStartFileToAddFormGroup = frm;
    this.addEditAutoStartFileModal.show();
  }

  
  onAddAutoStartFileModalAddClick() {
    this.validationHandler.onSubmitCheck(this.autoStartFileToAddFormGroup);
    if(!this.autoStartFileToAddFormGroup.valid){
      return;
    }

    this.addEditAccepted.emit(this.autoStartFileToAddFormGroup);
    this.addEditAutoStartFileModal.hide();
  }

}
